import React from 'react';

export interface StackedListProps {
  /**
   * React component to render inside Stacked List Item
   */
  children: React.ReactNode;
}

export const StackedList: React.FC<StackedListProps> = ({ children }: StackedListProps) => (
  <div className="max-w-5xl rounded-md bg-white shadow-sm w-full h-fit">
    <ul className="divide-y divide-gray-200">{children}</ul>
  </div>
);
